import CancellationPolicyInformation from './CancellationPolicyInformation';

export default CancellationPolicyInformation;
